// Zodiac: name, dates (start month/day inclusive), constellation lines
// Star coordinates in 0..100 viewBox.
// Star tuples are [x, y, mag]. Coordinates project real RA/Dec onto the 0..100 viewBox
// (east = larger x, north = smaller y), per-constellation scale. Lines = standard IAU asterism.
const ZODIAC = [
  // Aries: γ Mesarthim → β Sheratan → α Hamal → 41 Ari
  { key:'aries', name:'Bélier', symbol:'♈',
    range:[[3,21],[4,19]], dates:'21 mars — 19 avril',
    stars:[[15,75,3.86],[16,66,2.65],[32,49,2.00],[85,25,3.61]],
    lines:[[0,1],[1,2],[2,3]] },

  // Taurus: γ-δ-ε (Hyades V), α Aldebaran (eye), β Elnath (N horn), ζ (S horn)
  { key:'taurus', name:'Taureau', symbol:'♉',
    range:[[4,20],[5,20]], dates:'20 avril — 20 mai',
    stars:[[15,84,3.65],[18,74,3.77],[22,66,3.53],[29,80,0.85],[85,55,3.00],[74,15,1.65]],
    lines:[[0,1],[0,2],[1,3],[3,4],[2,5]] },

  // Gemini: η-μ-ε (Castor body/feet), α Castor & β Pollux (heads),
  //         δ-ζ-γ-ξ (Pollux body/feet)
  { key:'gemini', name:'Gémeaux', symbol:'♊',
    range:[[5,21],[6,20]], dates:'21 mai — 20 juin',
    stars:[[15,50,3.30],[21,50,2.87],[38,40,3.06],[77,15,1.58],[85,29,1.14],
           [66,51,3.50],[53,57,3.79],[33,72,1.93],[38,85,3.36]],
    lines:[[3,2],[2,1],[1,0],[4,5],[5,6],[6,7],[7,8],[3,4],[2,6]] },

  // Cancer: β Tarf (S foot), δ-γ-ι (central Y stem), α Acubens (E claw), ζ (W claw)
  { key:'cancer', name:'Cancer', symbol:'♋',
    range:[[6,21],[7,22]], dates:'21 juin — 22 juillet',
    stars:[[22,85,3.52],[64,53,3.94],[63,41,4.66],[67,15,4.02],[85,75,4.26],[15,55,4.70]],
    lines:[[0,1],[1,2],[2,3],[1,4],[1,5]] },

  // Leo: μ-ε-ζ-γ-η-α (sickle ending at Regulus), γ-δ-β-θ-α (body)
  { key:'leo', name:'Lion', symbol:'♌',
    range:[[7,23],[8,22]], dates:'23 juillet — 22 août',
    stars:[[15,15,3.88],[10,26,2.97],[31,28,3.43],[33,46,2.08],[24,61,3.48],
           [25,85,1.36],[67,68,3.33],[67,42,2.56],[90,72,2.14]],
    lines:[[1,0],[0,2],[2,3],[3,4],[4,5],[3,7],[7,8],[5,6],[6,8]] },

  // Virgo: β-η-γ (W arm), γ-δ-ε (N arm), γ-ζ-109 (E arm), ζ-ι-α Spica (S to Spica)
  { key:'virgo', name:'Vierge', symbol:'♍',
    range:[[8,23],[9,22]], dates:'23 août — 22 septembre',
    stars:[[10,43,3.59],[23,52,3.89],[33,55,2.74],[40,37,3.39],[43,10,2.83],
           [58,52,3.37],[90,43,3.72],[76,71,4.07],[53,90,0.97]],
    lines:[[0,1],[1,2],[2,3],[3,4],[2,5],[5,6],[5,7],[7,8]] },

  // Libra: α-β-γ (top scales triangle), α-σ (W arm), γ-υ-τ (E arm)
  { key:'libra', name:'Balance', symbol:'♎',
    range:[[9,23],[10,22]], dates:'23 septembre — 22 octobre',
    stars:[[15,38,2.74],[54,15,2.61],[82,33,3.91],[34,70,3.29],[84,79,3.60],[85,85,3.66]],
    lines:[[0,1],[1,2],[0,2],[0,3],[2,4],[4,5]] },

  // Scorpio: β-δ-π (claws), σ-α Antares-τ (heart), ε-μ-ζ-η-θ (curve), θ-κ-λ-υ (stinger)
  { key:'scorpio', name:'Scorpion', symbol:'♏',
    range:[[10,23],[11,21]], dates:'23 octobre — 21 novembre',
    stars:[[16,10,2.62],[12,20,2.32],[12,32,2.89],[33,33,1.06],[38,39,2.82],
           [49,60,2.29],[50,72,3.04],[52,87,3.62],[65,90,3.33],[83,89,1.87],
           [86,76,2.41],[80,69,1.62],[78,70,2.69]],
    lines:[[0,1],[1,2],[2,3],[3,4],[4,5],[5,6],[6,7],[7,8],[8,9],[9,10],[10,11],[11,12]] },

  // Sagittarius (Teapot): γ²-δ-ε (spout/base), ε-ζ (bottom), ζ-τ-σ-φ (handle),
  //                       φ-λ-δ (lid), λ-σ (lid top)
  { key:'sagittarius', name:'Sagittaire', symbol:'♐',
    range:[[11,22],[12,21]], dates:'22 novembre — 21 décembre',
    stars:[[10,54,2.99],[31,49,2.71],[35,85,1.85],[40,15,2.81],
           [63,27,3.17],[75,22,2.05],[90,33,3.32],[85,50,2.60]],
    lines:[[0,1],[1,2],[2,7],[7,6],[6,5],[5,4],[4,3],[3,1],[3,5]] },

  // Capricorn: α²-β (head), β-θ-ι-γ-δ (back), δ-ε-ζ-ω (descending), ω-β (closing)
  { key:'capricorn', name:'Capricorne', symbol:'♑',
    range:[[12,22],[1,19]], dates:'22 décembre — 19 janvier',
    stars:[[10,15,3.57],[13,26,3.05],[52,38,4.07],[68,36,4.27],[84,35,3.69],
           [90,32,2.81],[81,49,4.51],[71,63,3.74],[40,85,4.11]],
    lines:[[0,1],[1,2],[2,3],[3,4],[4,5],[5,6],[6,7],[7,8],[8,1]] },

  // Aquarius: ε-β-α (W body), γ + π/ζ/η (water jar Y), α-θ-λ-δ (water stream)
  { key:'aquarius', name:'Verseau', symbol:'♒',
    range:[[1,20],[2,18]], dates:'20 janvier — 18 février',
    stars:[[10,59,3.78],[38,43,2.87],[59,22,2.95],[69,26,3.85],[71,15,4.66],
           [74,21,3.65],[77,21,4.04],[66,52,4.16],[89,51,3.74],[90,85,3.27]],
    lines:[[0,1],[1,2],[2,3],[3,4],[3,5],[5,6],[2,7],[7,8],[8,9]] },

  // Pisces: β-γ-ι-λ-κ (Circlet, W fish), ι-ο-α Alrescha (cord+knot), α-η-τ (E fish)
  { key:'pisces', name:'Poissons', symbol:'♓',
    range:[[2,19],[3,20]], dates:'19 février — 20 mars',
    stars:[[10,79,4.48],[16,80,3.69],[26,74,4.12],[27,84,4.49],[20,85,4.95],
           [82,66,4.27],[90,81,3.79],[76,51,3.61],[67,15,4.50]],
    lines:[[0,1],[1,2],[2,3],[3,4],[4,0],[2,5],[5,6],[6,7],[7,8]] }
];

// ─────────── Sign calculator ───────────
function getSign(month, day){
  // dates inclusive
  const M = (a,b)=> month===a && day>=b;
  const m = (a,b)=> month===a && day<=b;
  if (M(3,21) || m(4,19)) return 'aries';
  if (M(4,20) || m(5,20)) return 'taurus';
  if (M(5,21) || m(6,20)) return 'gemini';
  if (M(6,21) || m(7,22)) return 'cancer';
  if (M(7,23) || m(8,22)) return 'leo';
  if (M(8,23) || m(9,22)) return 'virgo';
  if (M(9,23) || m(10,22)) return 'libra';
  if (M(10,23) || m(11,21)) return 'scorpio';
  if (M(11,22) || m(12,21)) return 'sagittarius';
  if (M(12,22) || m(1,19)) return 'capricorn';
  if (M(1,20) || m(2,18)) return 'aquarius';
  if (M(2,19) || m(3,20)) return 'pisces';
  return null;
}

// ─────────── Countries (ISO + dial code) ───────────
const COUNTRIES = [
  {name:'Afghanistan', iso:'AF', dial:'+93'},
  {name:'Albania', iso:'AL', dial:'+355'},
  {name:'Algeria', iso:'DZ', dial:'+213', example:'5 12 34 56 78'},
  {name:'Andorra', iso:'AD', dial:'+376'},
  {name:'Angola', iso:'AO', dial:'+244'},
  {name:'Anguilla', iso:'AI', dial:'+1264'},
  {name:'Antigua and Barbuda', iso:'AG', dial:'+1268'},
  {name:'Argentina', iso:'AR', dial:'+54'},
  {name:'Armenia', iso:'AM', dial:'+374'},
  {name:'Aruba', iso:'AW', dial:'+297'},
  {name:'Australia', iso:'AU', dial:'+61'},
  {name:'Austria', iso:'AT', dial:'+43'},
  {name:'Azerbaijan', iso:'AZ', dial:'+994'},
  {name:'Bahamas', iso:'BS', dial:'+1242'},
  {name:'Bahrain', iso:'BH', dial:'+973', example:'3600 1234'},
  {name:'Bangladesh', iso:'BD', dial:'+880'},
  {name:'Barbados', iso:'BB', dial:'+1246'},
  {name:'Belarus', iso:'BY', dial:'+375'},
  {name:'Belgium', iso:'BE', dial:'+32', example:'470 12 34 56'},
  {name:'Belize', iso:'BZ', dial:'+501'},
  {name:'Benin', iso:'BJ', dial:'+229'},
  {name:'Bermuda', iso:'BM', dial:'+1441'},
  {name:'Bhutan', iso:'BT', dial:'+975'},
  {name:'Bolivia', iso:'BO', dial:'+591'},
  {name:'Bosnia and Herzegovina', iso:'BA', dial:'+387'},
  {name:'Botswana', iso:'BW', dial:'+267'},
  {name:'Brazil', iso:'BR', dial:'+55'},
  {name:'British Virgin Islands', iso:'VG', dial:'+1284'},
  {name:'Brunei', iso:'BN', dial:'+673'},
  {name:'Bulgaria', iso:'BG', dial:'+359'},
  {name:'Burkina Faso', iso:'BF', dial:'+226'},
  {name:'Burundi', iso:'BI', dial:'+257'},
  {name:'Cambodia', iso:'KH', dial:'+855'},
  {name:'Cameroon', iso:'CM', dial:'+237'},
  {name:'Canada', iso:'CA', dial:'+1', example:'(416) 555 0132'},
  {name:'Cape Verde', iso:'CV', dial:'+238'},
  {name:'Cayman Islands', iso:'KY', dial:'+1345'},
  {name:'Central African Republic', iso:'CF', dial:'+236'},
  {name:'Chad', iso:'TD', dial:'+235'},
  {name:'Chile', iso:'CL', dial:'+56'},
  {name:'China', iso:'CN', dial:'+86'},
  {name:'Colombia', iso:'CO', dial:'+57'},
  {name:'Comoros', iso:'KM', dial:'+269'},
  {name:'Congo (DR)', iso:'CD', dial:'+243'},
  {name:'Congo (Republic)', iso:'CG', dial:'+242'},
  {name:'Cook Islands', iso:'CK', dial:'+682'},
  {name:'Costa Rica', iso:'CR', dial:'+506'},
  {name:"Côte d'Ivoire", iso:'CI', dial:'+225'},
  {name:'Croatia', iso:'HR', dial:'+385'},
  {name:'Cuba', iso:'CU', dial:'+53'},
  {name:'Curaçao', iso:'CW', dial:'+599'},
  {name:'Cyprus', iso:'CY', dial:'+357'},
  {name:'Czech Republic', iso:'CZ', dial:'+420'},
  {name:'Denmark', iso:'DK', dial:'+45'},
  {name:'Djibouti', iso:'DJ', dial:'+253'},
  {name:'Dominica', iso:'DM', dial:'+1767'},
  {name:'Dominican Republic', iso:'DO', dial:'+1'},
  {name:'Ecuador', iso:'EC', dial:'+593'},
  {name:'Egypt', iso:'EG', dial:'+20', example:'10 1234 5678'},
  {name:'El Salvador', iso:'SV', dial:'+503'},
  {name:'Equatorial Guinea', iso:'GQ', dial:'+240'},
  {name:'Eritrea', iso:'ER', dial:'+291'},
  {name:'Estonia', iso:'EE', dial:'+372'},
  {name:'Eswatini', iso:'SZ', dial:'+268'},
  {name:'Ethiopia', iso:'ET', dial:'+251'},
  {name:'Falkland Islands', iso:'FK', dial:'+500'},
  {name:'Faroe Islands', iso:'FO', dial:'+298'},
  {name:'Fiji', iso:'FJ', dial:'+679'},
  {name:'Finland', iso:'FI', dial:'+358'},
  {name:'France', iso:'FR', dial:'+33', example:'6 12 34 56 78'},
  {name:'French Guiana', iso:'GF', dial:'+594'},
  {name:'French Polynesia', iso:'PF', dial:'+689'},
  {name:'Gabon', iso:'GA', dial:'+241'},
  {name:'Gambia', iso:'GM', dial:'+220'},
  {name:'Georgia', iso:'GE', dial:'+995'},
  {name:'Germany', iso:'DE', dial:'+49', example:'1512 3456789'},
  {name:'Ghana', iso:'GH', dial:'+233'},
  {name:'Greece', iso:'GR', dial:'+30'},
  {name:'Greenland', iso:'GL', dial:'+299'},
  {name:'Grenada', iso:'GD', dial:'+1473'},
  {name:'Guadeloupe', iso:'GP', dial:'+590'},
  {name:'Guatemala', iso:'GT', dial:'+502'},
  {name:'Guinea', iso:'GN', dial:'+224'},
  {name:'Guinea-Bissau', iso:'GW', dial:'+245'},
  {name:'Guyana', iso:'GY', dial:'+592'},
  {name:'Haiti', iso:'HT', dial:'+509'},
  {name:'Honduras', iso:'HN', dial:'+504'},
  {name:'Hong Kong', iso:'HK', dial:'+852'},
  {name:'Hungary', iso:'HU', dial:'+36'},
  {name:'Iceland', iso:'IS', dial:'+354'},
  {name:'India', iso:'IN', dial:'+91', example:'98765 43210'},
  {name:'Indonesia', iso:'ID', dial:'+62'},
  {name:'Iran', iso:'IR', dial:'+98'},
  {name:'Iraq', iso:'IQ', dial:'+964'},
  {name:'Ireland', iso:'IE', dial:'+353'},
  {name:'Israel', iso:'IL', dial:'+972'},
  {name:'Italy', iso:'IT', dial:'+39', example:'312 345 6789'},
  {name:'Jamaica', iso:'JM', dial:'+1876'},
  {name:'Japan', iso:'JP', dial:'+81'},
  {name:'Jordan', iso:'JO', dial:'+962', example:'7 9012 3456'},
  {name:'Kazakhstan', iso:'KZ', dial:'+7'},
  {name:'Kenya', iso:'KE', dial:'+254'},
  {name:'Kiribati', iso:'KI', dial:'+686'},
  {name:'Kosovo', iso:'XK', dial:'+383'},
  {name:'Kuwait', iso:'KW', dial:'+965', example:'500 12345'},
  {name:'Kyrgyzstan', iso:'KG', dial:'+996'},
  {name:'Laos', iso:'LA', dial:'+856'},
  {name:'Latvia', iso:'LV', dial:'+371'},
  {name:'Lebanon', iso:'LB', dial:'+961', example:'70 123 456'},
  {name:'Lesotho', iso:'LS', dial:'+266'},
  {name:'Liberia', iso:'LR', dial:'+231'},
  {name:'Libya', iso:'LY', dial:'+218'},
  {name:'Liechtenstein', iso:'LI', dial:'+423'},
  {name:'Lithuania', iso:'LT', dial:'+370'},
  {name:'Luxembourg', iso:'LU', dial:'+352'},
  {name:'Macau', iso:'MO', dial:'+853'},
  {name:'Madagascar', iso:'MG', dial:'+261'},
  {name:'Malawi', iso:'MW', dial:'+265'},
  {name:'Malaysia', iso:'MY', dial:'+60'},
  {name:'Maldives', iso:'MV', dial:'+960'},
  {name:'Mali', iso:'ML', dial:'+223'},
  {name:'Malta', iso:'MT', dial:'+356'},
  {name:'Marshall Islands', iso:'MH', dial:'+692'},
  {name:'Martinique', iso:'MQ', dial:'+596'},
  {name:'Mauritania', iso:'MR', dial:'+222'},
  {name:'Mauritius', iso:'MU', dial:'+230'},
  {name:'Mayotte', iso:'YT', dial:'+262'},
  {name:'Mexico', iso:'MX', dial:'+52'},
  {name:'Micronesia', iso:'FM', dial:'+691'},
  {name:'Moldova', iso:'MD', dial:'+373'},
  {name:'Monaco', iso:'MC', dial:'+377'},
  {name:'Mongolia', iso:'MN', dial:'+976'},
  {name:'Montenegro', iso:'ME', dial:'+382'},
  {name:'Montserrat', iso:'MS', dial:'+1664'},
  {name:'Morocco', iso:'MA', dial:'+212', example:'6 12 34 56 78'},
  {name:'Mozambique', iso:'MZ', dial:'+258'},
  {name:'Myanmar', iso:'MM', dial:'+95'},
  {name:'Namibia', iso:'NA', dial:'+264'},
  {name:'Nauru', iso:'NR', dial:'+674'},
  {name:'Nepal', iso:'NP', dial:'+977'},
  {name:'Netherlands', iso:'NL', dial:'+31', example:'6 12345678'},
  {name:'New Caledonia', iso:'NC', dial:'+687'},
  {name:'New Zealand', iso:'NZ', dial:'+64'},
  {name:'Nicaragua', iso:'NI', dial:'+505'},
  {name:'Niger', iso:'NE', dial:'+227'},
  {name:'Nigeria', iso:'NG', dial:'+234'},
  {name:'North Korea', iso:'KP', dial:'+850'},
  {name:'North Macedonia', iso:'MK', dial:'+389'},
  {name:'Norway', iso:'NO', dial:'+47'},
  {name:'Oman', iso:'OM', dial:'+968', example:'9123 4567'},
  {name:'Pakistan', iso:'PK', dial:'+92'},
  {name:'Palau', iso:'PW', dial:'+680'},
  {name:'Palestine', iso:'PS', dial:'+970'},
  {name:'Panama', iso:'PA', dial:'+507'},
  {name:'Papua New Guinea', iso:'PG', dial:'+675'},
  {name:'Paraguay', iso:'PY', dial:'+595'},
  {name:'Peru', iso:'PE', dial:'+51'},
  {name:'Philippines', iso:'PH', dial:'+63'},
  {name:'Poland', iso:'PL', dial:'+48'},
  {name:'Portugal', iso:'PT', dial:'+351', example:'912 345 678'},
  {name:'Puerto Rico', iso:'PR', dial:'+1'},
  {name:'Qatar', iso:'QA', dial:'+974', example:'3312 3456'},
  {name:'Réunion', iso:'RE', dial:'+262'},
  {name:'Romania', iso:'RO', dial:'+40'},
  {name:'Russia', iso:'RU', dial:'+7'},
  {name:'Rwanda', iso:'RW', dial:'+250'},
  {name:'Saint Kitts and Nevis', iso:'KN', dial:'+1869'},
  {name:'Saint Lucia', iso:'LC', dial:'+1758'},
  {name:'Saint Pierre and Miquelon', iso:'PM', dial:'+508'},
  {name:'Saint Vincent and the Grenadines', iso:'VC', dial:'+1784'},
  {name:'Samoa', iso:'WS', dial:'+685'},
  {name:'San Marino', iso:'SM', dial:'+378'},
  {name:'São Tomé and Príncipe', iso:'ST', dial:'+239'},
  {name:'Saudi Arabia', iso:'SA', dial:'+966', example:'50 123 4567'},
  {name:'Senegal', iso:'SN', dial:'+221'},
  {name:'Serbia', iso:'RS', dial:'+381'},
  {name:'Seychelles', iso:'SC', dial:'+248'},
  {name:'Sierra Leone', iso:'SL', dial:'+232'},
  {name:'Singapore', iso:'SG', dial:'+65'},
  {name:'Sint Maarten', iso:'SX', dial:'+1721'},
  {name:'Slovakia', iso:'SK', dial:'+421'},
  {name:'Slovenia', iso:'SI', dial:'+386'},
  {name:'Solomon Islands', iso:'SB', dial:'+677'},
  {name:'Somalia', iso:'SO', dial:'+252'},
  {name:'South Africa', iso:'ZA', dial:'+27'},
  {name:'South Korea', iso:'KR', dial:'+82'},
  {name:'South Sudan', iso:'SS', dial:'+211'},
  {name:'Spain', iso:'ES', dial:'+34', example:'612 34 56 78'},
  {name:'Sri Lanka', iso:'LK', dial:'+94'},
  {name:'Sudan', iso:'SD', dial:'+249'},
  {name:'Suriname', iso:'SR', dial:'+597'},
  {name:'Sweden', iso:'SE', dial:'+46'},
  {name:'Switzerland', iso:'CH', dial:'+41', example:'78 123 45 67'},
  {name:'Syria', iso:'SY', dial:'+963'},
  {name:'Taiwan', iso:'TW', dial:'+886'},
  {name:'Tajikistan', iso:'TJ', dial:'+992'},
  {name:'Tanzania', iso:'TZ', dial:'+255'},
  {name:'Thailand', iso:'TH', dial:'+66'},
  {name:'Timor-Leste', iso:'TL', dial:'+670'},
  {name:'Togo', iso:'TG', dial:'+228'},
  {name:'Tonga', iso:'TO', dial:'+676'},
  {name:'Trinidad and Tobago', iso:'TT', dial:'+1868'},
  {name:'Tunisia', iso:'TN', dial:'+216', example:'20 123 456'},
  {name:'Turkey', iso:'TR', dial:'+90', example:'501 234 56 78'},
  {name:'Turkmenistan', iso:'TM', dial:'+993'},
  {name:'Turks and Caicos', iso:'TC', dial:'+1649'},
  {name:'Tuvalu', iso:'TV', dial:'+688'},
  {name:'Uganda', iso:'UG', dial:'+256'},
  {name:'Ukraine', iso:'UA', dial:'+380'},
  {name:'United Arab Emirates', iso:'AE', dial:'+971', example:'50 123 4567'},
  {name:'United Kingdom', iso:'GB', dial:'+44', example:'7911 123456'},
  {name:'United States', iso:'US', dial:'+1', example:'(415) 555 0132'},
  {name:'Uruguay', iso:'UY', dial:'+598'},
  {name:'Uzbekistan', iso:'UZ', dial:'+998'},
  {name:'Vanuatu', iso:'VU', dial:'+678'},
  {name:'Vatican City', iso:'VA', dial:'+379'},
  {name:'Venezuela', iso:'VE', dial:'+58'},
  {name:'Vietnam', iso:'VN', dial:'+84'},
  {name:'Yemen', iso:'YE', dial:'+967'},
  {name:'Zambia', iso:'ZM', dial:'+260'},
  {name:'Zimbabwe', iso:'ZW', dial:'+263'},
];

const isoToFlag = (iso) =>
  String(iso).toUpperCase().replace(/[A-Z]/g, c =>
    String.fromCodePoint(127397 + c.charCodeAt(0))
  );

function detectDefaultCountry(){
  return 'MA';
}

// custom dropdowns (Day / Month / Year / Country)
(function setupCustomDropdowns(){
  const days = Array.from({length:31}, (_,i)=>(
    { value:String(i+1), label:String(i+1).padStart(2,'0') }
  ));
  const monthNames = ['Janvier','Février','Mars','Avril','Mai','Juin',
                      'Juillet','Août','Septembre','Octobre','Novembre','Décembre'];
  const months = monthNames.map((label, i)=>({ value:String(i+1), label }));

  initSelect('dvDay',   days,   'Jour');
  initSelect('dvMonth', months, 'Mois');

  const countryItems = COUNTRIES.map(c => ({
    value:   c.dial,
    label:   c.name,
    iso:     c.iso,
    flag:    isoToFlag(c.iso),
    dial:    c.dial,
    example: c.example || ''
  }));
  const defaultIso  = detectDefaultCountry();
  const defaultItem = countryItems.find(c => c.iso === defaultIso)
                   || countryItems.find(c => c.iso === 'MA')
                   || countryItems[0];

  initSelect('dvCountry', countryItems, 'Pays', {
    searchable: true,
    triggerRenderer: (it) =>
      `<span class="dv-flag" aria-hidden="true">${it.flag}</span>` +
      `<span class="dv-iso">${it.iso}</span>`,
    optionRenderer: (it) =>
      `<span class="dv-option-flag" aria-hidden="true">${it.flag}</span>` +
      `<span class="dv-option-name">${it.label}</span>` +
      `<span class="dv-option-dial">${it.dial}</span>`,
    onCommit: (it) => {
      const prefixEl = document.getElementById('phonePrefix');
      const isoEl    = document.getElementById('countryIso');
      const phoneEl  = document.getElementById('whatsapp');
      if(prefixEl) prefixEl.textContent = it.dial;
      if(isoEl)    isoEl.value = it.iso;
      if(phoneEl)  phoneEl.placeholder = it.example || 'Numéro de téléphone';
    },
    initialItem: defaultItem ? (it) => it.iso === defaultItem.iso : null
  });

  function initSelect(rootId, items, placeholder, opts){
    opts = opts || {};
    const searchable      = !!opts.searchable;
    const triggerRenderer = opts.triggerRenderer || null;
    const optionRenderer  = opts.optionRenderer  || null;
    const onCommit        = opts.onCommit        || null;
    const initialValue    = opts.initialValue != null ? opts.initialValue : null;
    const initialItem     = opts.initialItem     || null;

    const root        = document.getElementById(rootId);
    const trigger     = root.querySelector('.dv-select__trigger');
    const list        = root.querySelector('.dv-select__options');
    const valueEl     = root.querySelector('.dv-select__value');
    const hiddenInput = root.querySelector('input[type="hidden"]');
    const searchWrap  = searchable ? root.querySelector('.dv-select__search') : null;
    const searchInput = searchWrap ? searchWrap.querySelector('input') : null;

    list.innerHTML = items.map((it, i) => {
      const inner = optionRenderer ? optionRenderer(it) : it.label;
      return `<li role="option" data-value="${it.value}" data-index="${i}" aria-selected="false">${inner}</li>`;
    }).join('');

    let activeIndex = -1;
    let typeBuf = '';
    let typeTimer = null;
    const allLis     = () => Array.from(list.querySelectorAll('li:not(.dv-no-results)'));
    const visibleLis = () => allLis().filter(li => !li.hidden);
    const itemFor    = (li) => items[parseInt(li.dataset.index, 10)];

    function setNoResults(show){
      let nr = list.querySelector('li.dv-no-results');
      if(show){
        if(!nr){
          nr = document.createElement('li');
          nr.className = 'dv-no-results';
          nr.setAttribute('aria-hidden','true');
          nr.textContent = 'Aucun pays trouvé';
          list.appendChild(nr);
        }
        nr.hidden = false;
      } else if(nr){
        nr.hidden = true;
      }
    }

    function applyFilter(query){
      const q = String(query || '').trim().toLowerCase();
      if(!q){
        allLis().forEach(li => { li.hidden = false; });
        setNoResults(false);
        return;
      }
      let any = false;
      allLis().forEach(li => {
        const it = itemFor(li);
        const hay = ((it.label || '') + ' ' + (it.dial || '') + ' ' + (it.iso || '')).toLowerCase();
        const match = hay.indexOf(q) !== -1;
        li.hidden = !match;
        if(match) any = true;
      });
      setNoResults(!any);
    }

    function open(){
      if(root.classList.contains('is-open')) return;
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded','true');
      if(searchInput){
        searchInput.value = '';
        applyFilter('');
      }
      const visible = visibleLis();
      const selIdx  = visible.findIndex(li => li.getAttribute('aria-selected') === 'true');
      setActive(selIdx >= 0 ? selIdx : 0, true);
      document.addEventListener('mousedown', onOutsideDown);
      if(searchInput){
        requestAnimationFrame(() => searchInput.focus());
      }
    }
    function close(){
      if(!root.classList.contains('is-open')) return;
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded','false');
      setActive(-1);
      if(searchInput){
        searchInput.value = '';
        applyFilter('');
      }
      document.removeEventListener('mousedown', onOutsideDown);
    }
    function toggle(){
      root.classList.contains('is-open') ? close() : open();
    }
    function setActive(i, scroll){
      const visible = visibleLis();
      allLis().forEach(li => li.removeAttribute('data-active'));
      if(i >= 0 && visible[i]){
        visible[i].setAttribute('data-active','true');
        if(scroll) visible[i].scrollIntoView({ block:'nearest' });
      }
      activeIndex = i;
    }
    function commit(li, opts2){
      opts2 = opts2 || {};
      allLis().forEach(x => x.setAttribute('aria-selected','false'));
      li.setAttribute('aria-selected','true');
      hiddenInput.value = li.dataset.value;
      const it = itemFor(li);
      if(triggerRenderer){
        valueEl.innerHTML = triggerRenderer(it);
      } else {
        valueEl.textContent = it.label;
      }
      valueEl.dataset.placeholder = 'false';
      root.classList.remove('has-error');
      if(onCommit) onCommit(it);
      hiddenInput.dispatchEvent(new Event('change', { bubbles:true }));
      if(!opts2.silent){
        close();
        trigger.focus();
      }
    }
    function onOutsideDown(e){
      if(!root.contains(e.target)) close();
    }
    function typeAhead(ch){
      typeBuf = (typeBuf + ch).toLowerCase();
      clearTimeout(typeTimer);
      typeTimer = setTimeout(() => { typeBuf = ''; }, 600);
      const visible = visibleLis();
      const start = activeIndex >= 0 ? activeIndex : 0;
      for(let step = 0; step < visible.length; step++){
        const idx = (start + (typeBuf.length === 1 ? step + 1 : step)) % visible.length;
        if(visible[idx].textContent.toLowerCase().startsWith(typeBuf)){
          setActive(idx, true);
          return;
        }
      }
    }

    function handleNavKey(e, isOpen){
      if(e.key === 'ArrowDown' || e.key === 'ArrowUp'){
        e.preventDefault();
        if(!isOpen){ open(); return true; }
        const visible = visibleLis();
        if(!visible.length) return true;
        const next = e.key === 'ArrowDown'
          ? Math.min(activeIndex + 1, visible.length - 1)
          : Math.max(activeIndex - 1, 0);
        setActive(next, true);
        return true;
      }
      if(e.key === 'Home'){
        if(isOpen){ e.preventDefault(); setActive(0, true); }
        return true;
      }
      if(e.key === 'End'){
        if(isOpen){ e.preventDefault(); setActive(visibleLis().length - 1, true); }
        return true;
      }
      if(e.key === 'Enter'){
        if(!isOpen){ e.preventDefault(); open(); return true; }
        const visible = visibleLis();
        if(activeIndex >= 0 && visible[activeIndex]){
          e.preventDefault();
          commit(visible[activeIndex]);
        }
        return true;
      }
      if(e.key === 'Escape'){
        if(isOpen){ e.preventDefault(); close(); trigger.focus(); }
        return true;
      }
      if(e.key === 'Tab'){
        if(isOpen) close();
        return true;
      }
      return false;
    }

    valueEl.textContent = placeholder;
    valueEl.dataset.placeholder = 'true';

    trigger.addEventListener('click', toggle);
    trigger.addEventListener('keydown', (e) => {
      const isOpen = root.classList.contains('is-open');
      if(e.key === ' '){
        e.preventDefault();
        if(!isOpen){ open(); return; }
        const visible = visibleLis();
        if(activeIndex >= 0 && visible[activeIndex]) commit(visible[activeIndex]);
        return;
      }
      if(handleNavKey(e, isOpen)) return;
      if(searchable) return;
      if(/^[a-zA-Z0-9]$/.test(e.key)){
        if(!isOpen) open();
        typeAhead(e.key);
      }
    });

    if(searchable && searchInput){
      searchInput.addEventListener('input', (e) => {
        applyFilter(e.target.value);
        setActive(visibleLis().length ? 0 : -1, false);
      });
      searchInput.addEventListener('keydown', (e) => {
        const isOpen = root.classList.contains('is-open');
        handleNavKey(e, isOpen);
      });
      searchWrap.addEventListener('mousedown', (e) => e.stopPropagation());
    }

    list.addEventListener('click', (e) => {
      const li = e.target.closest('li');
      if(li && list.contains(li) && !li.classList.contains('dv-no-results')) commit(li);
    });
    list.addEventListener('mousemove', (e) => {
      const li = e.target.closest('li');
      if(!li || li.classList.contains('dv-no-results')) return;
      const visible = visibleLis();
      const idx = visible.indexOf(li);
      if(idx !== -1 && idx !== activeIndex) setActive(idx, false);
    });

    if(initialItem){
      const idx = items.findIndex(initialItem);
      if(idx >= 0){
        const target = list.querySelector('li[data-index="' + idx + '"]');
        if(target) commit(target, { silent:true });
      }
    } else if(initialValue !== null){
      const target = allLis().find(li => li.dataset.value === String(initialValue));
      if(target) commit(target, { silent:true });
    }
  }
})();

// live readout
function updateReadout(){
  const m = parseInt(document.getElementById('dobMonth').value,10);
  const d = parseInt(document.getElementById('dobDay').value,10);
  const readout = document.getElementById('signReadout');
  const glyph = document.getElementById('signGlyphReadout');
  if(!m || !d){ readout.classList.remove('show'); return; }
  // adjust max day
  const daysIn = new Date(2024, m, 0).getDate();
  if(d > daysIn){ readout.classList.remove('show'); return; }
  const key = getSign(m, d);
  if(!key) return;
  const sign = ZODIAC.find(z=>z.key===key);
  glyph.textContent = `${sign.name} ${sign.symbol}`;
  readout.classList.add('show');
}
['dobDay','dobMonth'].forEach(id=>{
  document.getElementById(id).addEventListener('change', updateReadout);
});

// ─────────── Form submit ───────────
// The form posts into a hidden iframe (target="divini-form-target"). That keeps
// Shopify's storefront-forms-hcaptcha hook happy (it requires a *native* form
// submit to inject its CAPTCHA token), while the visible page never navigates.
// When the iframe's `load` event fires after a submit we triggered, we reveal
// the thanks state.

function upsertHidden(form, name, value){
  let i = form.querySelector('input[type="hidden"][name="'+name+'"]');
  if(!i){
    i = document.createElement('input');
    i.type = 'hidden';
    i.name = name;
    form.appendChild(i);
  }
  i.value = value;
}

let _diviniPendingSign = null;

document.getElementById('reserveForm').addEventListener('submit', (e)=>{
  const f = e.target;
  const dial   = f.countryDial.value;                       // e.g. "+212"
  const local  = f.whatsapp.value.trim().replace(/^0+/, '');// strip leading zeros
  const digits = local.replace(/\D/g, '');                  // digits only
  const data = {
    fullName:   f.fullName.value.trim(),
    email:      f.email.value.trim(),
    countryIso: f.countryIso.value,
    dob: { day: f.dobDay.value, month: f.dobMonth.value },
    consent:    f.consent.checked
  };
  // E.164: + then dial digits then local digits, no spaces.
  data.whatsapp = dial && digits ? (dial.replace(/\s+/g,'') + digits) : '';

  const phoneOk = !!dial && digits.length >= 6;
  if (!data.fullName || !phoneOk ||
     !data.dob.day || !data.dob.month || !data.consent){
    e.preventDefault();
    const missing = [
      ['dvCountry', dial],
      ['dvDay',     data.dob.day],
      ['dvMonth',   data.dob.month]
    ];
    missing.forEach(([id, val]) => {
      if(!val){
        const el = document.getElementById(id);
        el.classList.remove('has-error');
        void el.offsetWidth;
        el.classList.add('has-error');
        setTimeout(() => el.classList.remove('has-error'), 2400);
      }
    });
    f.reportValidity();
    return;
  }
  const key = getSign(parseInt(data.dob.month,10), parseInt(data.dob.day,10));
  const sign = ZODIAC.find(z=>z.key===key);
  data.zodiac = key;

  // Inject contact[*] fields directly into the form so the native POST carries them.
  const nameParts = data.fullName.split(/\s+/);
  upsertHidden(f, 'contact[first_name]', nameParts[0]);
  if(nameParts.length > 1) upsertHidden(f, 'contact[last_name]', nameParts.slice(1).join(' '));
  if(data.email) upsertHidden(f, 'contact[email]', data.email);
  // Shopify's /contact?form_type=customer endpoint silently drops contact[phone].
  // We still send it (in case Shopify ever accepts it) AND encode it as a tag so
  // the number is preserved + searchable in admin.
  upsertHidden(f, 'contact[phone]', data.whatsapp);
  const phoneDigits = (data.whatsapp || '').replace(/[^0-9]/g, '');
  const tagParts = [
    'pre-launch',
    'zodiac-' + (data.zodiac || 'unknown'),
    'country-' + (data.countryIso || 'xx').toLowerCase(),
    'dob-' + (data.dob.day || '') + '-' + (data.dob.month || '')
  ];
  if(phoneDigits) tagParts.push('phone-' + phoneDigits);
  upsertHidden(f, 'contact[tags]', tagParts.join(','));
  if(data.consent) upsertHidden(f, 'contact[accepts_marketing]', 'true');

  // Mark this submit as ours so the iframe's load event reveals the thanks state.
  _diviniPendingSign = sign;

  // Defensive: ensure the form targets our hidden iframe even if Liquid attribute didn't apply.
  if(f.target !== 'divini-form-target') f.target = 'divini-form-target';

  // No preventDefault → native submission to iframe → hCaptcha injects token → /contact POST.
});

// Iframe load handler: when our pending submit completes inside the iframe,
// reveal the thanks state on the visible page.
(function bindIframeSubmitWatcher(){
  const iframe = document.getElementById('diviniFormTarget');
  if(!iframe) return;
  iframe.addEventListener('load', () => {
    if(!_diviniPendingSign) return;
    const sign = _diviniPendingSign;
    _diviniPendingSign = null;
    const f = document.getElementById('reserveForm');
    const thanks = document.getElementById('thanks');
    const youAre = document.getElementById('youAre');
    if(f) f.style.display = 'none';
    const reserveInner = document.querySelector('.reserve .reserve-inner');
    if(reserveInner) reserveInner.classList.add('is-thanks');
    if(youAre){
      youAre.textContent = sign ? (sign.name + ' ' + sign.symbol) : '—';
    }
    if(thanks) thanks.classList.add('show');
  });
})();

// ─────────── Header scroll-state veil ───────────
(function headerScrollState(){
  const h = document.querySelector('header');
  if(!h) return;
  let raf = 0;
  const update = () => {
    h.classList.toggle('is-scrolled', window.scrollY > 16);
    raf = 0;
  };
  window.addEventListener('scroll', () => {
    if(!raf) raf = requestAnimationFrame(update);
  }, { passive:true });
  update();
})();

// ─────────── Starfield (canvas) ───────────
(function(){
  const cv = document.getElementById('starfield');
  const ctx = cv.getContext('2d');
  let W,H, stars=[], shooting=[];
  function resize(){
    W = cv.width = window.innerWidth * devicePixelRatio;
    H = cv.height = window.innerHeight * devicePixelRatio;
    cv.style.width = window.innerWidth+'px';
    cv.style.height = window.innerHeight+'px';
    init();
  }
  function init(){
    stars = [];
    const count = Math.floor((window.innerWidth*window.innerHeight)/2200);
    for(let i=0;i<count;i++){
      stars.push({
        x: Math.random()*W,
        y: Math.random()*H,
        r: (Math.random()*1.1+0.2) * devicePixelRatio,
        a: Math.random()*0.6+0.2,
        tw: Math.random()*0.012+0.003,
        ph: Math.random()*Math.PI*2,
        col: Math.random()<0.08 ? '#cdb685' : '#f4f0d8'
      });
    }
  }
  function spawnShooting(){
    if(Math.random()<0.004 && shooting.length<2){
      shooting.push({
        x: Math.random()*W*0.6 + W*0.2,
        y: Math.random()*H*0.4,
        vx: (5+Math.random()*4)*devicePixelRatio,
        vy: (1.5+Math.random()*1.5)*devicePixelRatio,
        life: 1
      });
    }
  }
  function frame(t){
    ctx.clearRect(0,0,W,H);
    for(const s of stars){
      const a = s.a * (0.7 + 0.3*Math.sin(t*s.tw + s.ph));
      ctx.beginPath();
      ctx.fillStyle = s.col;
      ctx.globalAlpha = a;
      ctx.arc(s.x, s.y, s.r, 0, Math.PI*2);
      ctx.fill();
    }
    ctx.globalAlpha = 1;
    spawnShooting();
    for(let i=shooting.length-1;i>=0;i--){
      const sh = shooting[i];
      sh.x += sh.vx; sh.y += sh.vy; sh.life -= 0.012;
      if(sh.life<=0){ shooting.splice(i,1); continue; }
      const grad = ctx.createLinearGradient(sh.x, sh.y, sh.x-60*devicePixelRatio, sh.y-20*devicePixelRatio);
      grad.addColorStop(0, `rgba(255,245,210,${sh.life})`);
      grad.addColorStop(1, 'rgba(255,245,210,0)');
      ctx.strokeStyle = grad;
      ctx.lineWidth = 1.4*devicePixelRatio;
      ctx.beginPath();
      ctx.moveTo(sh.x, sh.y);
      ctx.lineTo(sh.x-60*devicePixelRatio, sh.y-20*devicePixelRatio);
      ctx.stroke();
    }
    requestAnimationFrame(frame);
  }
  window.addEventListener('resize', resize);
  resize();
  requestAnimationFrame(frame);
})();
